module.exports = RedNaoFormBuilder.default('FormBuilder/Core/Conditions/ConditionProcessorBase');